<script>
import { Errors } from 'form-backend-validation'
import { trim } from 'lodash'
import { groupBy } from 'lodash'
import moment from 'moment'
import { mapActions } from 'vuex'
import * as FileDownload from 'downloadjs'
export default {
  name: 'performanceReport',
  data() {
    return {
      loading: false,
      errors: new Errors(),
      rangeDate: [moment(), moment()],
      customers: [],
      projects: [],
      categories: [],
      resources: [],
      taskOwners: [],
      model: {
        dateRange: [
          moment()
            .startOf('month')
            .format('DD-MM-YYYY'),
          moment()
            .endOf('month')
            .format('DD-MM-YYYY')
        ],
        project_id: undefined,
        category_id: undefined,
        customer_id: undefined,
        employee_id: undefined
      }
    }
  },
  mounted() {
    this.fetchResource()
  },
  computed: {
    groupByCustomer() {
      return groupBy(this.resources, 'customer_name')
    }
  },
  methods: {
    moment,
    ...mapActions('report/project', [
      'getCustomer',
      'getProject',
      'getCategory',
      'performances',
      'getOwner',
      'performancesExcel'
    ]),
    dateRangeChange(rangeDate) {
      this.model.dateRange[0] = rangeDate[0].format('DD-MM-YYYY')
      this.model.dateRange[1] = rangeDate[1].format('DD-MM-YYYY')
    },
    filter(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    onProjectChange(value) {
      console.log(value)
    },
    onGetCategory() {},
    async fetchResource() {
      this.loading = true
      const response = await Promise.all([
        this.getCustomer(),
        this.getCategory(),
        this.getOwner()
      ])
      const [customer, category, owners] = response
      this.customers = customer.map(el => ({
        value: el.customer_id,
        label: el.customer_name
      }))
      this.categories = category.map(el => ({
        value: el.category_id,
        label: el.category_name_en
      }))

      this.taskOwners = owners.map((el) => ({
        value: el.employee_id,
        label: el.employee_name_en
      }))

      this.loading = false
    },
    onCustomerChange(value) {
      this.loading = true
      this.getProject({
        customer_id: value
      })
        .then(response => {
          this.projects = response.map(el => ({
            value: el.project_id,
            label: el.project_name
          }))
        })
        .finally(() => (this.loading = false))
    },
    onPreview() {
      this.loading = true
      this.performances(this.model)
        .then(response => {
          this.resources = response.data
        })
        .catch(err => {
          this.$toasted.error(err.message)
          this.errors = new Errors(err.errors)
        })
        .finally(() => (this.loading = false))
    },
    exportExcel() {
      this.loading = true
      this.errors = new Errors()
      this.performancesExcel(this.model)
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.loading = false))
    }
  }
}
</script>

<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('performanceReport.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('performanceReport.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-loading-banner :loading="loading">
      <div class="row">
        <div class="col-md-3">
          <div class="form-group ts-h-full">
            <ts-card class="ts-h-full">
              <ts-card-wrapper class="ts-h-full">
                <form>
                  <fieldset>
                    <legend>{{ $t('performanceReport.criteria') }}</legend>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="required">{{
                            $t('performanceReport.dateRange')
                          }}</label>
                          <a-range-picker
                            format="DD-MM-YYYY"
                            :defaultValue="rangeDate"
                            :defaultPickerValue="rangeDate"
                            :allowClear="false"
                            @change="dateRangeChange"
                            :ranges="{
                              Today: [moment(), moment()],
                              'This Month': [
                                moment().startOf('month'),
                                moment().endOf('month')
                              ]
                            }"
                          >
                            <template slot="renderExtraFooter"></template>
                          </a-range-picker>
                          <div class="validate" v-if="errors.has('date_range')">
                            {{ errors.first('date_range') }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>{{ $t('performanceReport.customer') }}</label>
                          <a-select
                            v-model="model.customer_id"
                            :options="customers"
                            showSearch
                            :filterOption="filter"
                            placeholder="All"
                            mode="multiple"
                            class="ts-w-full"
                            :max-tag-count="1"
                            @change="onCustomerChange"
                          >
                          </a-select>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>{{ $t('performanceReport.project') }}</label>
                          <a-select
                            v-model="model.project_id"
                            :options="projects"
                            showSearch
                            :filterOption="filter"
                            placeholder="All"
                            mode="multiple"
                            class="ts-w-full"
                            :max-tag-count="1"
                          >
                          </a-select>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>{{ $t('performanceReport.taskOwner') }}</label>
                          <a-select
                            v-model="model.employee_id"
                            :options="taskOwners"
                            showSearch
                            :filterOption="filter"
                            placeholder="All"
                            mode="multiple"
                            class="ts-w-full"
                            :max-tag-count="1"
                          >
                          </a-select>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>{{
                            $t('performanceReport.productCategory')
                          }}</label>
                          <a-select
                            v-model="model.category_id"
                            :options="categories"
                            showSearch
                            :filterOption="filter"
                            placeholder="All"
                            mode="multiple"
                            class="ts-w-full"
                            :max-tag-count="1"
                          >
                          </a-select>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div
                        class="col-md-12 ts-flex ts-justify-end ts-space-x-2"
                      >
                        <ts-button @click="onPreview" color="primary">{{
                          $t('preview')
                        }}</ts-button>
                        <ts-button @click="exportExcel" color="info">{{
                          $t('excel')
                        }}</ts-button>
                      </div>
                    </div>
                  </fieldset>
                </form>
              </ts-card-wrapper>
            </ts-card>
          </div>
        </div>
        <div class="col-md-9">
          <div class="form-group ts-h-full">
            <ts-card class="ts-h-full">
              <ts-card-wrapper class="ts-h-full">
                <h1 class="ts-text-base">
                  {{ $t('performanceReport.preview') }}
                </h1>
                <div class="ts-w-full ts-h-full">
                  <div
                    v-if="resources.length === 0"
                    class="ts-w-full ts-h-full ts-flex ts-justify-center ts-items-center"
                  >
                    <div class="ts-text-center">
                      <i class="fas fa-folder-open fa-3x ts-text-gray-400"></i>
                      <div>
                        {{ $t('noData') }}
                      </div>
                    </div>
                  </div>
                  <div
                    v-else
                    class="ts-mt-8 ts-overflow-auto"
                    style="height: 350px;"
                  >
                    <table class="ts-w-full">
                      <thead>
                        <tr>
                          <th
                            class="ts-uppercase ts-font-semibold ts-bg-gray-100 ts-py-2 ts-px-2 ts-sticky ts-top-0 ts-w-10"
                          >
                            No
                          </th>
                          <th
                            class="ts-uppercase ts-font-semibold ts-bg-gray-100 ts-py-2 ts-px-2 ts-sticky ts-top-0"
                          >
                            {{ $t('performanceReport.project') }}
                          </th>
                          <th
                            class="ts-uppercase ts-font-semibold ts-bg-gray-100 ts-py-2 ts-px-2 ts-sticky ts-top-0"
                          >
                            {{ $t('performanceReport.task') }}
                          </th>
                          <th
                            class="ts-uppercase ts-font-semibold ts-bg-gray-100 ts-py-2 ts-px-2 ts-sticky ts-top-0"
                          >
                            {{ $t('performanceReport.productName') }}
                          </th>
                          <th
                            class="ts-uppercase ts-font-semibold ts-bg-gray-100 ts-py-2 ts-px-2 ts-sticky ts-top-0"
                          >
                            {{ $t('performanceReport.uom') }}
                          </th>
                          <th
                            class="ts-uppercase ts-font-semibold ts-bg-gray-100 ts-py-2 ts-px-2 ts-sticky ts-top-0 ts-text-center"
                          >
                            {{ $t('performanceReport.qty') }}
                          </th>
                          <th
                            class="ts-uppercase ts-font-semibold ts-bg-gray-100 ts-py-2 ts-px-2 ts-sticky ts-top-0 ts-text-center"
                          >
                            {{ $t('performanceReport.estimateQty') }}
                          </th>
                          <th
                            class="ts-uppercase ts-font-semibold ts-bg-gray-100 ts-py-2 ts-px-2 ts-sticky ts-top-0 ts-text-center"
                          >
                            {{ $t('performanceReport.accumulateQty') }}
                          </th>
                          <th
                            class="ts-uppercase ts-font-semibold ts-bg-gray-100 ts-py-2 ts-px-2 ts-sticky ts-top-0"
                          >
                            {{ $t('performanceReport.owner') }}
                          </th>
                          <th
                            class="ts-uppercase ts-font-semibold ts-bg-gray-100 ts-py-2 ts-px-2 ts-sticky ts-top-0"
                          >
                            {{ $t('performanceReport.status') }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-for="(items, customer) in groupByCustomer">
                          <tr class="ts-border-b">
                            <td
                              colspan="8"
                              class="ts-py-2 ts-px-2 ts-font-bold ts-text-blue-500"
                            >
                              {{ customer }}
                            </td>
                          </tr>
                          <tr v-for="(item, index) in items">
                            <td class="ts-px-2 ts-py-1">{{ index + 1 }}</td>
                            <td class="ts-px-2 ts-py-1">
                              {{ item.project_name }}
                            </td>
                            <td class="ts-px-2 ts-py-1">{{ item.title }}</td>
                            <td class="ts-px-2 ts-py-1">
                              {{ item.product_name_en }}
                            </td>
                            <td class="ts-px-2 ts-py-1">
                              {{ item.uom_name_en }}
                            </td>
                            <td class="ts-px-2 ts-py-1 ts-text-center">
                              {{ item.quantity }}
                            </td>
                            <td class="ts-px-2 ts-py-1 ts-text-center">
                              {{ item.estimate_qty }}
                            </td>
                            <td class="ts-px-2 ts-py-1 ts-text-center">
                              {{ item.accumulate_qty }}
                            </td>
                            <td class="ts-px-2 ts-py-1">
                              {{ item.task_owner }}
                            </td>
                            <td class="ts-px-2 ts-py-1">
                              {{ item.project_status }}
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </div>
              </ts-card-wrapper>
            </ts-card>
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>
